import { render } from "./budget-table.vue?vue&type=template&id=625f244a"
import script from "./budget-table.vue?vue&type=script&lang=js"
export * from "./budget-table.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/my.fastfinance.app/my.fastfinance.app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__